function initInventoryHomes(block) {
    if (block.dataset.p7InventoryHomesInit) return;
    block.dataset.p7InventoryHomesInit = '1';

    const gridContainer = block.querySelector('.p7-inventory-homes');
    const loadMoreBtn = block.querySelector('.p7-load-more');
    const loadingEl = block.querySelector('.p7-loading');
    const filters = block.querySelectorAll('.p7-filter');
    const resetBtn = block.querySelector('.p7-reset-filters');
    const pagination = block.querySelector('.p7-inventory-pagination');
    // const countElement  = block.querySelector('.p7-inventory-count');

    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const ajaxurl = block.dataset.ajaxurl;
    // const nonce = block.dataset.nonce;

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;
    let currentFilters = {};

    function serializeFilters() {
        const obj = {};
        filters.forEach(f => {
            if (f.type === 'checkbox') {
                if (!obj[f.name]) obj[f.name] = [];
                if (f.checked) obj[f.name].push(f.value);
            } else {
                if (f.value !== undefined && f.value !== '') {
                    obj[f.name] = f.value;
                }
            }
        });
        return obj;
    }

    function loadHomes(page = 1, filters = {}) {
        if (isLoading) return;
        isLoading = true;
        currentPage = page;

        // Show loading spinner and hide grid
        const isFirstPage = page === 1;

        // Only show loader when filters change or initial load
        if (isFirstPage) {
            if (loadingEl) loadingEl.style.display = 'flex';

            if (gridContainer) {
                gridContainer.style.opacity = '0';
                gridContainer.style.pointerEvents = 'none';
                gridContainer.style.display = 'none';
            }

            pagination.style.display = "none";
            gridContainer.innerHTML = '';
        }

        const body = new URLSearchParams({
            action: 'p7_load_homes',
            page: page.toString(),
            attributes: JSON.stringify(attributes),
            filters: JSON.stringify(filters)
        });

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) {
                    if (page === 1) {
                        gridContainer.innerHTML = data.data.html;
                    } else {
                        gridContainer.insertAdjacentHTML('beforeend', data.data.html);
                    }

                    // countElement && (countElement.textContent = `Showing ${data.data.showing} of ${data.data.total_found} results`);
                    // Observe new promo flags
                    observePromoFlags(gridContainer);



                    maxPages = data.data.max_pages;
                    currentPage = data.data.current_page;

                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = (currentPage < maxPages) ? 'flex' : 'none';
                    }
                } else {
                    console.error('Load homes error', data);
                }
            })
            .catch(err => console.error('AJAX Error:', err))
            .finally(() => {
                // Random delay between 3s and 5s
                setTimeout(() => {
                    isLoading = false;

                    if (isFirstPage) {
                        if (loadingEl) loadingEl.style.display = 'none';

                        if (gridContainer) {
                            gridContainer.style.opacity = '1';
                            gridContainer.style.pointerEvents = 'auto';
                            gridContainer.style.display = 'grid';
                        }

                        pagination.style.display = "flex";
                    }

                    if (typeof AOS !== "undefined") {
                        requestAnimationFrame(() => {
                            AOS.refreshHard();
                        });
                    }
                }, 100);
            });
    }

    function observePromoFlags(container) {
        const promoFlags = container.querySelectorAll(
            '.p7-inventory-home-photo-wrapper .promo-flags, \
         .p7-inventory-home-photo-wrapper .type_flag img'
        );
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                    observer.unobserve(entry.target); // animate once only
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: "0px 0px -50px 0px"
        });
        promoFlags.forEach(flag => observer.observe(flag));
    }

    function applyFilters() {
        currentFilters = serializeFilters();

        localStorage.setItem(
            'p7_inventory_filters',
            JSON.stringify(currentFilters)
        );

        loadHomes(1, currentFilters);
    }

    function getFiltersFromStorage() {
        const stored = localStorage.getItem('p7_inventory_filters');
        return stored ? JSON.parse(stored) : {};
    }

    function resetFilters() {
        filters.forEach(f => {
            if (f.type === 'checkbox' || f.type === 'radio') f.checked = false;
            else f.value = '';
        });
        currentFilters = {};
        localStorage.removeItem('p7_inventory_filters');
        loadHomes(1, {});
    }

    function hydrateFilters(filters) {
        filters.forEach(f => {
            const value = currentFilters[f.name];

            if (!value) return;

            if (f.type === 'checkbox') {
                if (Array.isArray(value)) {
                    f.checked = value.includes(f.value);
                }
            } else {
                f.value = value;
            }
        });
    }

    // window.addEventListener('popstate', () => {
    //     currentFilters = getFiltersFromURL();
    //     hydrateFilters(filters);
    //     loadHomes(1, currentFilters);
    // });

    currentFilters = getFiltersFromStorage();
    hydrateFilters(filters);
    loadHomes(1, currentFilters);

    loadMoreBtn?.addEventListener('click', () => loadHomes(currentPage + 1, currentFilters));
    filters.forEach(f => f.addEventListener('change', applyFilters));
    resetBtn?.addEventListener('click', resetFilters);


}

// MutationObserver to initialize new blocks dynamically
const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
        m.addedNodes.forEach(node => {
            if (!(node instanceof Element)) return;
            if (node.classList.contains('p7-inventory-homes-block')) {
                initInventoryHomes(node);
            }
            node.querySelectorAll('.p7-inventory-homes-block').forEach(initInventoryHomes);
        });
    });
});

if (document.body instanceof Element) {
    observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize existing blocks on page load
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.p7-inventory-homes-block').forEach(initInventoryHomes);
});

document.addEventListener("click", function (e) {

    const btn = e.target.closest(".spec-share");
    if (!btn) return;

    const title = encodeURIComponent(btn.dataset.title);
    const url = btn.dataset.url;
    const encodedUrl = encodeURIComponent(url);

    // Email
    document.querySelector("#spec-share-popup .share-email").href =
        `mailto:?subject=${title}&body=${encodedUrl}`;

    // Facebook
    document.querySelector("#spec-share-popup .share-facebook").href =
        `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

    // Copy link
    const copyBtn = document.querySelector("#spec-share-popup .copy-link-btn");
    if (copyBtn && !copyBtn.dataset.bound) {
        copyBtn.dataset.bound = "true";
        // wrap text node only once
        if (!copyBtn.querySelector(".copy-text")) {
            const textNode = document.createElement("span");
            textNode.className = "copy-text";
            textNode.textContent = "Copy Link";

            // remove text and re-append svg + span
            const svg = copyBtn.querySelector("svg");
            copyBtn.innerHTML = "";
            copyBtn.appendChild(svg);
            copyBtn.appendChild(textNode);
        }
        const textEl = copyBtn.querySelector(".copy-text");
        copyBtn.addEventListener("click", async () => {
            try {
                await navigator.clipboard.writeText(url);
                const original = textEl.textContent;
                textEl.textContent = "Copied!";
                setTimeout(() => {
                    textEl.textContent = original;
                }, 2000);
            } catch (err) {
                console.log("Copy failed", err);
            }
        });

    }

});

document.addEventListener('click', function (e) {

    const btn = e.target.closest('.tour.btn-scendery');
    if (!btn) return;

    const href = btn.getAttribute('href');

    if (!href || !href.startsWith('#')) return;

    e.preventDefault();

    const anchor = href.replace('#', '');

    const popupWrapper = document.querySelector(
        `.guten-popup-builder[data-anchor="${anchor}"]`
    );

    const popup = popupWrapper?.querySelector('.guten-popup');

    if (popup) {
        popup.classList.add('show');
    }

    // populate Gravity Forms fields
    setTimeout(() => {

        const plan = btn.dataset.plan || '';
        const community = btn.dataset.community || '';
        const spec = btn.dataset.spec || '';

        const communityField = popupWrapper.querySelector('#input_9_6');
        const planField = popupWrapper.querySelector('#input_9_7');
        const specField = popupWrapper.querySelector('#input_9_8');

        if (communityField) communityField.value = community;
        if (planField) planField.value = plan;
        if (specField) specField.value = spec;

    }, 300);

});
